import React from 'react';

export const stripHtml = (text: string) =>
    text ? text.toString().replace(/(<([^>]+)>)/gi, '') : text;

export const nl2br = (text: string, ignoreLast = true) => {
    let items;
    ignoreLast
        ? (items = text.split('\n').filter((item) => item.length > 0))
        : (items = text.split('\n'));

    return items.map(
        (item, key) =>
            item.length > 0 && (
                <span key={key}>
                    {item}
                    {items.length !== ++key && <br />}
                </span>
            ),
    );
};

export const isPdf = (fileName: string): boolean => {
    return /(pdf)$/gi.test(fileName.substr(fileName.lastIndexOf('.') + 1));
};

export const stripStyle = (text: string) =>
    text
        ? text
              .toString()
              .replace(/<style>[^</]*<\/style>/gi, '')
              .replace(/^\s*[\r\n]/gm, '')
        : text;

export const stripStyleAndHtml = (text: string) =>
    text ? stripHtml(stripStyle(text)) : text;
